import { autoinject } from 'aurelia-framework';

@autoinject
export class UserAdminCard {
 
  constructor() {
   
  }

  bind(bindingContext: any, overrideContext: any) {
   
  }

  attached() {
    
  }

  detached() {
   
  }

}